import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    ChangeRequestsResponse,
    DnoConfigResponse,
    IDnoConfigResponse,
    IChangeRequestsResponse,
    ILicenceAreaThresholdsResponse,
    ILockStatusResponse,
    LicenceAreaThresholdsResponse,
    LockStatusResponse,
} from "../../types/dnoThreshold/dnoThresholdTypes"

export const dnoThresholdMapper = {
    mapCurrentConfig: (response: unknown): IDnoConfigResponse => {
        const res = tsIoValidate<IDnoConfigResponse>(
            DnoConfigResponse,
            response,
            "Error mapping DNO config."
        )
        return res
    },

    mapLicenceAreaThresholds: (
        response: unknown
    ): ILicenceAreaThresholdsResponse => {
        const res = tsIoValidate<ILicenceAreaThresholdsResponse>(
            LicenceAreaThresholdsResponse,
            response,
            "Error mapping licence area thresholds."
        )
        return res
    },

    mapChangeRequests: (response: unknown): IChangeRequestsResponse => {
        const res = tsIoValidate<IChangeRequestsResponse>(
            ChangeRequestsResponse,
            response,
            "Error mapping change requests."
        )
        return res
    },

    mapLockStatus: (response: unknown): ILockStatusResponse => {
        const res = tsIoValidate<ILockStatusResponse>(
            LockStatusResponse,
            response,
            "Error mapping lock status."
        )
        return res
    },
}
